import { Box, SxProps } from "@mui/system";
import Header, { HeaderProps } from "./Header";

type Props = {
  backgroundUrl?: string;
  sx?: SxProps;
} & HeaderProps;

export default function ImageHeader(props: Props) {
  const sx: SxProps = {
    p: 5,
    pb: 2,
    background: `url(${props.backgroundUrl}) no-repeat`,
    backgroundPosition: "0 0",
    backgroundSize: "100% auto",
    ...props.sx
  };

  return <Box sx={sx} >
    <Header { ...props }/>
  </Box>;
}
